import { BaseParkingFacilityDetailContent } from '@/components/map/details/content/BaseParkingFacilityDetailContent';
import { useForecast } from '@/hooks/useForecast';
import type { ParkAndRideFacility, ParkAndRideFacilityData } from '@/modules/api/backend';

interface DetailCardParkingFacilityContentProps {
  facility: ParkAndRideFacility;
  data?: ParkAndRideFacilityData;
}

export function ParkAndRideFacilityDetailContent({ facility, data }: DetailCardParkingFacilityContentProps) {
  const { horizonItems: forecast } = useForecast(facility.rmvId === '3001535PR01' ? {} : { url: '' });

  return <BaseParkingFacilityDetailContent data={data} facility={facility} forecast={forecast} />;
}
